import { makeAxiosInstance } from 'mailup-react-helpers'

import { beAccountSettingsApiGetSessionOauth2Token } from 'Api/beAccountSettingsApi'

import { APP_CLIENT_ID } from 'Constants'
import { logApiError, logApiTiming } from './logger'

const refreshToken = async seckey => {
  const { token } = await beAccountSettingsApiGetSessionOauth2Token({
    seckey,
    client_id: APP_CLIENT_ID,
    force: true
  })

  return token
}

const apiWrapper = makeAxiosInstance({
  refreshToken,
  apiTimeLog: logApiTiming,
  apiErrorLog: logApiError
})
export default apiWrapper

export const extractApiData = r => r.data
